import './travel-slider.scss';
import Swiper from 'swiper/bundle';
export default () => {
	new Swiper('.js-travel-slider', {
		slidesPerView: 1,
		loop: true,
		pagination: {
			el: ".travel-pagination",
			clickable: true,
		},
	});
};
